// extracted by mini-css-extract-plugin
export default {"brandCarousel":"brandCarousel_brandCarousel__OuQ-b"};